T<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap >
      <v-flex lg12>
        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modalturma.dialog" persistent max-width="900px">
            <v-btn color="primary" dark slot="activator">Nova Turma</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Cadastrando uma Turma</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select
                      label="Selecione o treinamento"
                      :items="trainings"
                      v-model="turma.training_id"
                      autocomplete
                      item-text="name"
                      item-value="id"                           
                      ></v-select>
                    </v-flex>
                    <v-flex lg4>  
                      <v-text-field
                      label="Nome"
                      v-model="turma.name"
                      :rules="[rules.required]"
                      required>
                    </v-text-field>
                  </v-flex>                     
                  <v-flex xs4>
                    <v-text-field
                    label="Local"
                    v-model="turma.local"
                    :rules="[rules.required]"
                    required></v-text-field>
                  </v-flex>                     
                  <v-flex xs4>
                    <v-text-field
                    label="Cidade"
                    v-model="turma.city"
                  ></v-text-field>
                  </v-flex>                       
                  <v-flex xs4>
                    <v-menu
                    class="pr-2"
                    ref="statDate"
                    lazy
                    :close-on-content-click="false"
                    v-model="startDateMenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-bottom="-22"
                    max-width="290px"
                    :return-value.sync="startDate"
                    >
                    <v-text-field
                    slot="activator"
                    label="Data de Início"
                    v-model="dateFormattedinico"
                    @blur="dateinicio = parseDate(dateFormatted)"
                    prepend-icon="event"
                    readonly
                    ></v-text-field>
                    <v-date-picker v-model="dateinicio" locale="pt-br" @input="$refs.statDate.save(turma.date)" >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4>
                  <v-menu
                  class="pr-2"
                  ref="endDateTermino"
                  lazy
                  :close-on-content-click="false"
                  v-model="startTerminoDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-bottom="-22"
                  max-width="290px"
                  :return-value.sync="startDateTermino"
                  >
                  <v-text-field
                  slot="activator"
                  label="Data de Término"
                  v-model="dateFormatteddateend"
                  @blur="dateend = parseDate(dateFormatted)"
                  prepend-icon="event"
                  readonly
                  ></v-text-field>
                  <v-date-picker v-model="dateend" locale="pt-br" @input="$refs.endDateTermino.save(turma.dateend)">
                  </v-date-picker>
                </v-menu>
              </v-flex>                     
              <v-flex xs4>
                <v-menu
                class="pr-2"
                ref="endDate"
                lazy
                :close-on-content-click="false"
                v-model="endDateMenu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-22"
                max-width="290px"
                :return-value.sync="startDate"
                >
                <v-text-field
                slot="activator"
                label="Data de validade"
                v-model="dateFormattedvalidy"
                @blur="datevalidy = parseDate(dateFormatted)"
                prepend-icon="event"
                readonly
                ></v-text-field>
                <v-date-picker v-model="datevalidy" locale="pt-br" @input="$refs.endDate.save(turma.validity)">
                </v-date-picker>
              </v-menu>
            </v-flex>                
            <v-flex xs2>
              <v-text-field
              type="number"
              label="Horas de curso"
              v-model="turma.hours"
              :rules="[rules.required]"
              required>
            </v-text-field>
          </v-flex>                  
          <v-flex xs5>
            <v-select
            label="Selecione o instrutor"
            :items="instructors"
            v-model="turma.instructor_id"
            autocomplete
            item-text="name"
            item-value="id"                           
            ></v-select>
          </v-flex>              
          <v-flex xs5>
            <v-select
            label="Selecione o Responsável"
            :items="responsaveis"
            v-model="turma.responsible_id"
            autocomplete
            item-text="name"
            item-value="id"                           
            ></v-select>
          </v-flex>                             
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click.native="modalturma.dialog = false">Fechar</v-btn>
      <v-btn color="blue darken-1" flat @click="creatTurma()">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</div>

</v-flex>

<!-- tabela de treinamentos -->  
<v-flex lg12>
  <vue-good-table
  :columns="columns"
  :rows="teams"
  
  @on-cell-click="onCellClick"
  :pagination-options="{
  enabled: true,
  nextLabel: 'next',
  prevLabel: 'prev',
  rowsPerPageLabel: 'Registros por página',
  ofLabel: 'of',
  allLabel: 'Todos',
}"
styleClass="vgt-table bordered vgt-table condensed">
</vue-good-table>
</v-flex>



<!-- modal editando turma -->
<v-flex>
  <v-dialog v-model="modaleditturma.dialog" persistent max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Editando Turma</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
              label="Selecione o treinamento"
              :items="trainings"
              v-model="dados_teams.training_id"
              autocomplete
              item-text="name"
              item-value="id"                           
              ></v-select>
            </v-flex>
            <v-flex lg4>  
              <v-text-field
              label="Nome"
              v-model="dados_teams.name"
              :rules="[rules.required]"
              required>
            </v-text-field>
          </v-flex>                     
          <v-flex xs4>
            <v-text-field
            label="Local"
            v-model="dados_teams.local"
            :rules="[rules.required]"
            required></v-text-field>
          </v-flex>             
          <v-flex xs4>
            <v-text-field
            label="Cidade"
            v-model="dados_teams.city"
            ></v-text-field>
          </v-flex>                       
          <v-flex xs4>
            <v-menu
            class="pr-2"
            ref="statDateEdit"
            lazy
            :close-on-content-click="false"
            v-model="startDateMenuEdit"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-bottom="-22"
            max-width="290px"
            :return-value.sync="startDateEdit"
            >
            <v-text-field
            slot="activator"
            label="Data de Início"
            v-model="dateFormattedinico"
            @blur="dateinicio = parseDate(dateFormatted)"
            append-icon="event"
            readonly
            ></v-text-field>
            <v-date-picker v-model="dateinicio" locale="pt-br" @input="$refs.statDateEdit.save(dados_teams.date)">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4>
          <v-menu
          class="pr-2"
          ref="endDateTerminoEdit"
          lazy
          :close-on-content-click="false"
          v-model="endDateTerminoMenuEdit"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-bottom="-22"
          max-width="290px"
          :return-value.sync="startDate"
          >
          <v-text-field
          slot="activator"
          label="Data de Termino"
          v-model="dateFormatteddateend"
          @blur="dateend = parseDate(dateFormatted)"
          append-icon="event"
          readonly
          ></v-text-field>
          <v-date-picker v-model="dateend" locale="pt-br" @input="$refs.endDateTerminoEdit.save(dados_teams.dateend)">
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-menu>
      </v-flex>                        
      <v-flex xs4>
        <v-menu
        class="pr-2"
        ref="endDateEdit"
        lazy
        :close-on-content-click="false"
        v-model="endDateMenuEdit"
        transition="scale-transition"
        offset-y
        full-width
        :nudge-bottom="-22"
        max-width="290px"
        :return-value.sync="startDate"
        >
        <v-text-field
        slot="activator"
        label="Data de validade"
        v-model="dateFormattedvalidy"
        @blur="datevalidy = parseDate(dateFormatted)"
        append-icon="event"
        readonly
        ></v-text-field>
        <v-date-picker v-model="datevalidy" locale="pt-br" @input="$refs.endDateEdit.save(dados_teams.validity)">
          <v-spacer></v-spacer>
        </v-date-picker>
      </v-menu>
    </v-flex>        
    <v-flex xs2>
      <v-text-field
      type="number"
      label="Horas de curso"
      v-model="dados_teams.hours"
      :rules="[rules.required]"
      required>
    </v-text-field>
  </v-flex>  
  <v-flex xs5>
    <v-select
    label="Selecione o instrutor"
    :items="instructors"
    v-model="dados_teams.instructor_id"
    autocomplete
    item-text="name"
    item-value="id"                           
    ></v-select>
  </v-flex>          
  <v-flex xs5>
    <v-select
    label="Selecione o responsável"
    :items="responsaveis"
    v-model="dados_teams.responsible_id"
    autocomplete
    item-text="name"
    item-value="id"                           
    ></v-select>
  </v-flex>                             
</v-layout>
</v-container>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn color="blue darken-1" flat @click="fecharModalEditarTurma()">Fechar</v-btn>
  <v-btn color="blue darken-1" flat @click="updateTurma()">Salvar</v-btn>
</v-card-actions>
</v-card>
</v-dialog>
</v-flex>   


<!-- modal ver alunos -->
<v-flex>
  <v-dialog v-model="modalveralunos.dialog" persistent max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Alunos da Turma: </span>
        <input type="text" v-model="dados_teams.name" class="form-control" style="font-size: 25px!important; margin-left: 2px" disabled>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>   
              <vue-good-table
              :columns="columnsalunoscertificado"
              :rows="alunosteams"
              @on-row-click="clickFuncGerarCertificado"
              :pagination-options="{
              enabled: true,
              perPage: 5,
            }"
            styleClass="vgt-table bordered vgt-table condensed"
            theme="black-rhino">
          </vue-good-table>
          <v-flex lg12>
            <label><strong>OBS: Clique no nome aluno para gerar o certificado!</strong></label>
          </v-flex>  
        </v-flex>                                               
      </v-layout>
    </v-container>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" flat @click="fecarmodalVerAlunos()">Fechar</v-btn>
    <v-btn color="blue darken-1" flat @click="gerarTodosCertificadosdaTurma()">Gerar todos certificados</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>
</v-flex>



<!-- modal certificado --> 
<v-flex>
  <v-dialog v-model="modalacertificado.dialog" persistent max-width="100%">
    <v-card>
      <v-card-title>
        <span class="headline">Certificado da Turma</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <div v-if="!image">
                <input type="file" @change="onFileChange">
              </div>
              <div v-else>
                <img :src="image" />
                <v-btn color="blue darken-1" flat @click="removeImage">Remover</v-btn>
              </div>
            </v-flex>                                              
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="modalacertificado.dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-flex> 


<v-flex>
 <div class="col-md-12" style="float: right;">
  <v-dialog v-model="modalalunosturma.dialog" scrollable max-width="80%">
    <v-card>
      <v-card-title >
        <span class="headline">Cadastrando aluno na Turma:</span>   
        <strong><input type="text" v-model="dados_teams.name" class="form-control" style="font-size: 25px!important; margin-left: 10px" disabled></strong>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <v-layout wrap>
            <!-- se tiver tabela de alunos inseridos-->  
            <v-flex lg4>  
              <v-text-field
              label="Digite nome da empresa ou do funcionário"
              v-model="funcionario.name"
              required>
            </v-text-field>
          </v-flex>
          <v-flex lg3>
            <v-btn color="primary" @click="buscarFuncionarios()" :loading="loading" class="v-btn v-btn--small theme--dark primary">Buscar</v-btn>
          </v-flex>           
          <v-flex lg4 style="float: right;">
            <v-card-title >
              <span class="headline">Alunos inseridos na Turma</span>
            </v-card-title>             
          </v-flex> 

          <!-- após clicar em aluno -->
          <v-flex lg5 v-if="divAlunos">
            <vue-good-table
            :columns="columnsemployeesall"
            :rows="employeesall"
            @on-row-click="clickFunc"
            :pagination-options="{
            enabled: true,
            perPage: 5,
          }"
          styleClass="vgt-table bordered vgt-table condensed">
        </vue-good-table>
      </v-flex>
      <!-- após clicar em aluno -->

      <v-flex lg2 v-if="divAlunos">
        <strong ><i aria-hidden="true" class="v-icon material-icons" style="font-size: 100px!important; margin-left: 50px;">arrow_right_alt</i></strong>
      </v-flex>  

      <!-- tabela dos alunos adicionas na turma -->
      <v-flex lg5 v-if="divAlunos">
        <vue-good-table
        :columns="columnsalunos"
        :rows="alunosteams"
        @on-row-click="clickFuncDelete"
        :pagination-options="{
        enabled: true,
        perPage: 5,
      }"
      styleClass="vgt-table bordered vgt-table condensed"
      theme="black-rhino">
    </vue-good-table>
  </v-flex>  
  <!-- tabela dos alunos adicionas na turma --> 

  <!-- tabela dos funcioanrios all -->
  <v-flex lg5 v-if="!divAlunos">
    <vue-good-table
    :columns="columnsemployeesall"
    :rows="employeesall"
    @on-row-click="clickFunc"
    :pagination-options="{
    enabled: true,
    perPage: 5,
  }"
  styleClass="vgt-table bordered vgt-table condensed">
</vue-good-table>
</v-flex>
<!-- tabela dos funcioanrios all -->

<v-flex lg2 v-if="!divAlunos">
  <strong ><i aria-hidden="true" class="v-icon material-icons" style="font-size: 100px!important; margin-left: 50px;">arrow_right_alt</i></strong>
</v-flex>  

<!-- tabela das alunos ja inseridos na turma -->
<v-flex lg5 v-if="!divAlunos">
  <vue-good-table
  :columns="columnsalunos"
  :rows="alunosteams"
  @on-row-click="clickFuncDelete"
  :pagination-options="{
  enabled: true,
  perPage: 5,
}"
styleClass="vgt-table bordered vgt-table condensed"
theme="black-rhino">
</vue-good-table>
</v-flex>
<!-- tabela dos funcioanrios all -->  

<v-flex lg5>
  <label><strong>OBS: Clique no aluno para adicionar a turma!</strong></label>
</v-flex>
<v-flex lg2></v-flex>
<v-flex lg5>
  <label><strong>OBS: Clique no aluno para excluir da turma!</strong></label>
</v-flex>     

</v-layout>
</v-container>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn color="blue darken-1" flat @click="fecharModalAlunos()">Fechar</v-btn>
  <v-btn color="blue darken-1" flat @click.native="modalalunosturma.dialog = false">Confirmar</v-btn>

</v-card-actions>
</v-card>
</v-dialog>
</div>
</v-flex> 



</v-layout>
</v-container>    

</template>

<script>
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
import axios from 'axios';
export default {
  data () {
    return {
      search: '',
      searchs: null,
      teams: [],
      trainings:[],
      dados_teams: [],
      employeesall:[],
      employees_pesq:[],
      companies: [],
      instructors:[],
      responsaveis:[],
      alunosteams:[],
      items:[],
      image:'',


      dateFormattedinico: null,
      dateFormattedvalidy: null,
      dateFormatteddateend: null,
      dateinicio: '',
      datevalidy: '',
      dateend: '',

      startTerminoDateMenu: false,
      startDateMenu: false,
      endDateMenu: false,
      startDate: null,
      endDate: null,      
      startDateTermino: null,      

      endDateTerminoMenuEdit: false,
      startDateMenuEdit: false,
      endDateMenuEdit: false,
      startDateEdit: null,
      endDateEdit: null,
      endDateTerminoEdit: null,


      loading: false,
      divAlunos: false,
      columns: [
      {
        label: 'Turma',
        field: 'name',
        filterOptions: {
          enabled: true,
          placeholder: 'Informe o nome da turma',
          filterDropdownItems: [], 
          filterFn: this.columnFilterFn,
        },
        tdClass: 'text-center',        
      },
      {
        label: 'Local',
        field: 'local',
        filterOptions: {
          enabled: true,
          placeholder: 'Informe o local', 
          filterDropdownItems: [],
          filterFn: this.columnFilterFn,
        },
        tdClass: 'text-center',
      },        
      {
        label: 'Data',
        field: 'date',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DD',
        dateOutputFormat: 'DD/MM/YYYY',
        filterOptions: {
          enabled: true,
          placeholder: 'Informe validade do curso', 
          filterDropdownItems: [],
          filterFn: this.columnFilterFn,
        },
        tdClass: 'text-center',
      },
      {
        label: 'Validade',
        field: 'validity',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DD',
        dateOutputFormat: 'DD/MM/YYYY',
        filterOptions: {
          enabled: true,
          placeholder: 'Informe validade do curso',  
          filterDropdownItems: [], 
          filterFn: this.columnFilterFn, 
        },
        tdClass: 'text-center',
      },        
      {
        label: 'Treinamento',
        field: 'training.name',
        filterOptions: {
          enabled: true,
          placeholder: 'Informe a descrição do treinamento',
          filterDropdownItems: [], 
          filterFn: this.columnFilterFn, 
        },
        sortable: false,
        tdClass: 'text-center',
      },
      {
        label: 'Editar',
        field: 'btnedit',
        html: true,
        sortable: false,
        tdClass: 'text-center',
      },      
      {
        label: 'Inserir Alunos',
        field: 'btnturmas',
        html: true,
        sortable: false,
        tdClass: 'text-center',
      },          
      {
        label: 'Certificados',
        field: 'btnalunos',
        html: true,
        sortable: false,
        tdClass: 'text-center',
      }
      ],

      columnsemployeesall: [
      {
        label: 'Razão Socal',
        field: 'company_name',
        tdClass: 'text-center',
      },          
      {
        label: 'Colaborador',
        field: 'employee_name',
        tdClass: 'text-center',
      },
      ],          

      columnsalunos: [
      {
        label: 'Aluno',
        field: 'name',
        tdClass: 'text-center',
      },          
      {
        label: 'Empresa',
        field: 'company.name',
        tdClass: 'text-center',
      },
      ],          
      columnsalunoscertificado: [
      {
        label: 'Aluno',
        field: 'name',
        filterOptions: {
          enabled: true, 
          placeholder: 'Informe o nome do aluno',  
          filterDropdownItems: [], 
          filterFn: this.columnFilterFn,
        },
        tdClass: 'text-center',
      },          
      {
        label: 'Empresa',
        field: 'company.name',
        filterOptions: {
          enabled: true, 
          placeholder: 'Informe o nome da empresa',  
          filterDropdownItems: [], 
          filterFn: this.columnFilterFn, 
        },
        tdClass: 'text-center',
      },
      ],

      turma: {
        name: '',
        local: '',
        date: '', 
        validity: '',
        training_id: '',
        instructor_id: '',
        responsible_id: '',
        dateend: '',
        hours: '',
        city: '',
      },
      funcionario:{
        name:'',
      },
      id_empresa: null,
      training_id: null,
      multi4: [],
      modalturma: {
        dialog: false
      },            
      modaleditturma: {
        dialog: false
      },                               
      modalalunosturma: {
        dialog: false
      },            
      modalveralunos: {
        dialog: false
      },
      modalacertificado:{
        dialog: false
      },    
      rules: {
        required: (value) => !!value || 'Campo Obrigtório.',
      },
    };
  },

  mounted () {
    this.buscaTurmas();
    this.buscaTreinamentos();
    this.buscaEmpresa();
    this.buscaInstructors();
    this.buscaResponsaveis();
    this.buscarAllFuncionarios();
  }, 

  watch: {
    searchs (val) {
      val && this.querySelections(val);
    },

    loader () {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => {
        this[l] = false;
      }, 3000);
      this.loader = null;
    },

    dateinicio (val) {
      console.log(val)
      this.dateFormattedinico = this.formatDate(this.dateinicio)
    },        

    datevalidy (val) {
      console.log(val)
      this.dateFormattedvalidy = this.formatDate(this.datevalidy)
    },        

    dateend (val) {
      console.log(val)
      this.dateFormatteddateend = this.formatDate(this.dateend)
    },

  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },


  methods: {


    formatDate (date) {
      if (!date) return null

        const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

        const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },


    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.image = '';
    },
    onCellClick(params)
    {
      console.log(params)

      if(params.column.field == 'btnturmas')
      {
        this.clickAddFunc(params)
      }else if(params.column.field == 'btnalunos')
      {
        this.clickVerAlunos(params)
      }else{
        this.clickTd(params)
      } 

    },

    querySelections (v) {
      
      this.loading = true;
            setTimeout(() => {
              this.items = this.trainings.filter(e => {
                return (e.country || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
              });
              this.loading = false;
            }, 500);
          },

          buscaEmpresa() {

            http.get('companies')
            .then(response => {
               this.companies = response.data;
             })
            .catch(error => {
            });
          },

          buscaInstructors() {
            http.get('instructors?instructors')
            .then(response => {

             this.instructors = response.data;
           })
            .catch(error => {
            });
          },          

          buscaResponsaveis() {
            http.get('instructors?responsibles')
            .then(response => {
             console.log(response.data);
             this.responsaveis = response.data;

           })
            .catch(error => {
              console.log();
            });
          },

          buscarAllFuncionarios(params)
          {
            http.get('employees-all')
            .then(response => {
              this.employeesall = response.data;
            })
            .catch(error => {

              console.log(response);
            });
          },


          buscarFuncionarios()
          {
           this.loading = true; 
           let nome = this.funcionario.name;
           
           http.get('employees-all?q='+nome)
           .then(response => {

            this.employeesall = response.data;
            swal({
              title: "Funcionários!",
              text: "localizados com sucesso!",
              icon: "success",
              timer: 1000,
              button: false

            });
            if(response.data.length == 0)
            {
              swal({
                title: "Verifique,",
                text: "não localizamos nenhuma informação!",
                icon: "warning",
                timer: 2000,
                button: false

              });
            }  
            this.loading = false;
          })
           .catch(error => {

            console.log(response);
          });
         },


         buscaTurmas() {

          http.get('teams')
          .then(response => {
           // console.log(response.data);
           this.teams = response.data;

           for (var team in this.teams) {
            this.teams[team].btnedit = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;" slot="activator"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">edit</i></div></button>'  
            this.teams[team].btnturmas = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">how_to_reg</i></div></button>' 
            this.teams[team].btnalunos = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">assignment</i></div></button>'
          }

        })
          .catch(error => {
            console.log();
          });
        },

        buscaTreinamentos() {

          http.get('trainings')
          .then(response => {

           this.trainings = response.data;

         })
          .catch(error => {
            console.log();
          });
        },


        creatTurma() {
          http.post('teams', {
            name: this.turma.name,
            local: this.turma.local,
            date: this.dateinicio,
            validity: this.datevalidy,
            dateend: this.dateend,
            training_id: this.turma.training_id,
            instructor_id: this.turma.instructor_id,
            responsible_id: this.turma.responsible_id,
            hours: this.turma.hours,
            city: this.turma.city,
          })
          .then(response => {

            this.modalturma.dialog = false;

            this.buscaTurmas();
            this.limpadatas();

            swal({
              title: "Turma!",
              text: "cadastrada com sucesso!",
              icon: "success",
              timer: 1000,
              button: false

            });
          })
          .catch(error => {
            console.log();
          });
        },

        clickTd(params)
        {
          if(params.row.id == null || params.row.id == '')
          {
            swal({
              title: "Não",
              text: "foi possível editar o cadastro!",
              icon: "success",
              timer: 1000,
              button: false

            });
          }  
          
          this.modaleditturma.dialog = true;

          let data = {
            id: params.row.id,
            name: params.row.name,
            local: params.row.local,
            date: params.row.date,
            validity: params.row.validity,
            training_id: params.row.training_id,
            instructor_id: params.row.instructor_id,
            responsible_id: params.row.responsible_id,
            hours: params.row.hours,
            active: params.row.active,
            city: params.row.city,
          }

          this.dateinicio = params.row.date;
          this.datevalidy = params.row.validity;
          this.dateend = params.row.dateend;

          this.dados_teams = data;
        },        

        clickVerAlunos(params)
        {
          if(params.row.id == null || params.row.id == '')
          {
            swal({
              title: "Não",
              text: "foi possível editar o cadastro!",
              icon: "success",
              timer: 1000,
              button: false

            });
          }

          let data = {
            id: params.row.id,
            name: params.row.name,
            local: params.row.local,
            date: params.row.date,
            validity: params.row.validity,
            dateend: params.row.dateend,
            training_id: params.row.training_id,
            user_id: params.row.user_id,
            hours: params.row.hours,
            active: params.row.active,
            city: params.row.city,
          }

          this.dados_teams = data;  
          
          this.buscarFuncionariosNaTurma(params);
          this.modalveralunos.dialog = true;
          
        },
        
        clickAddFunc(params)
        {
          if(params.row == null || params.row == '')
          {
            swal({
              title: "Não",
              text: "foi possível verificar a turma",
              icon: "error",
              timer: 2000,
              button: false

            });
          }  

          this.buscarAllFuncionarios(params); 
          this.buscarFuncionariosNaTurma(params);
          let data = {
            id: params.row.id,
            name: params.row.name,
            local: params.row.local,
            date: params.row.date,
            validity: params.row.validity,
            dateend: params.row.dateend,
            training_id: params.row.training_id,
            user_id: params.row.user_id,
            hours: params.row.hours,
            active: params.row.active,
            city: params.row.city,
          }

          this.dados_teams = data;
          this.modalalunosturma.dialog = true;


        },
        updateTurma()
        {
          http.put('teams/' + this.dados_teams.id, {
            name: this.dados_teams.name,
            local: this.dados_teams.local,
            date: this.dateinicio,
            validity: this.datevalidy,
            dateend: this.dateend,
            training_id: this.dados_teams.training_id,
            instructor_id: this.dados_teams.instructor_id,
            responsible_id: this.dados_teams.responsible_id,
            hours: this.dados_teams.hours,
            active: this.dados_teams.active,
            city: this.dados_teams.city,
          })
          .then(response => {

            this.buscaTurmas();
            this.limpadatas();
            
            this.modaleditturma.dialog = false;
            swal({
              title: "Turma!",
              text: "atualizada com sucesso!",
              icon: "success",
              timer: 1000,
              button: false

            });
            this.dados_teams.push(response.data);
            
          })
          .catch(error => {
            console.log()
          });
        },


        clickFunc(params)
        {
          if(params.row.employee_id == null || params.row.employee_id == '')
          {
            swal({
              title: "Não",
              text: "foi possível adicionar o funcionário a turma!",
              icon: "error",
              timer: 2000,
              button: false

            });
          }
          
          let teamid = this.dados_teams.id;
          let employeedid = params.row.employee_id;
          
          http.post('teams/' + teamid + '/employees/' + employeedid +'', {})
          .then(response => {
           this.alunosteams = response.data;
           this.divAlunos = true;

           swal({
            title: "Aluno!",
            text: "adicionado com sucesso!",
            icon: "success",
            timer: 1000,
            button: false

          });
         })
          .catch(e => {
            if(e.response.status == 500)
            {
             swal({
              title: "Atenção!",
              text: "Aluno já foi adiciona a turma, verifique na tabela ao lado!",
              icon: "warning",
              timer: 2200,
              button: false

            });
           }  
         })
        },

        buscarFuncionariosNaTurma(params)
        {
          let teamid = params.row.id;
          http.get('teams/' + teamid +'/employees')          
          .then(response => {
            this.alunosteams = response.data;
          })
          .catch(error => {
            console.log();
          });
        },

        clickFuncDelete(params)
        {

          console.log(params)
          let teamid = this.dados_teams.id;
          let id_aluno = params.row.id;
          swal({
            title: "Deseja deletar o aluno da turma?",
            text: "Após realizar esta operação, se for necessário deverá incluir novamente.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if(willDelete){

              http.delete('teams/' + teamid +'/employees/'+ id_aluno +'').then(response => {
                this.alunosteams = response.data;
              });  
              swal("Registro excluído com sucesso!", {
                icon: "success",
              });
            } else{
              swal("Não foi possível excluir o registro!")
            }
          });
        },

        clickCertificado(params)
        {
         if(params.row == null || params.row == '')
         {
          swal({
            title: "Não",
            text: "foi possível verificar certificado da turma",
            icon: "error",
            timer: 2000,
            button: false

          });
        }
        let teamId = params.row.id;
        let employeeId = 3;

        http.get('teams/'+ teamId +'/employees/'+ employeeId +'/cert', {responseType: 'arraybuffer'}, {

          headers: {
            'Content-Type': 'application/pdf',
            'responseType': 'arraybuffer',
          }

        })
        .then(response => {
         this.downloadFile(response, 'customFilename')
         swal({
          title: "Certificado!",
          text: "gerado com sucesso!",
          icon: "success",
          timer: 1000,
          button: false

        });
       })
        .catch(e => {
          if(e.response.status == 500)
          {
           swal({
            title: "Atenção!",
            text: "Não foi possível gerar o certificado!",
            icon: "warning",
            timer: 2200,
            button: false

          });
         }  
       })

        this.modalacertificado.dialog = true;

      },

      downloadFile(response, filename) {

        var newBlob = new Blob([response.body], {type: 'application/pdf'})
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }

        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = filename + '.pdf'
        link.click()
        setTimeout(function () {
          window.URL.revokeObjectURL(data)
        }, 100)
      },

      gerarTodosCertificadosdaTurma()
      {
       console.log(this.dados_teams.id)
       console.log(this.alunosteams.length)
       let teamId = this.dados_teams.id;
       let employeeId = this.alunosteams[0].id;

       //gerar varios certificados
       var $this = this;
       for (var i = 0; i < $this.alunosteams.length; i++) {

         http.get('teams/'+ teamId +'/employees/'+ $this.alunosteams[i].id +'/cert', {
          responseType: 'arraybuffer',
        })
         .then(response => {
           console.log(response.data);

           const blob = new Blob([response.data], {
            type: 'application/pdf',
          });
           var link = document.createElement('a');
           link.href = window.URL.createObjectURL(blob);
           link.download = "Certificado";
           link.click();

           swal({
            title: "Certificado!",
            text: "gerado com sucesso!",
            icon: "success",
            timer: 1000,
            button: false

          });
         })
         .catch(e => {
          console.log(e.response)
          if(e.response.status == 500)
          {
           swal({
            title: "Atenção!",
            text: "Não foi possível gerar o certificado!",
            icon: "warning",
            timer: 2200,
            button: false

          });
         }  
       })
       }
     },

     clickFuncGerarCertificado(params)
     {

       let team_id = this.dados_teams.id;
       let id_aluno = params.row.id;
       swal({
        title: "Deseja gerar o certificado do aluno?",
        text: "O download será feito automaticamente.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
       .then((willDelete) => {
        if(willDelete){

          http.get('teams/'+ team_id +'/employees/'+ id_aluno +'/cert', 
          {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/pdf',
            }
          } ).then(response => {
            const blob = new Blob([response.data], {
              type: 'application/pdf',
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "Certificado_" + params.row.name;
            link.click();
          });  
          swal("Certificado gerado com sucesso!", {
            icon: "success",
            timer: 2500,
            button: false
          });
        } else{
          swal("Não foi possível gerar o certificado!")
        }
      });
     },

     fecharModalEditarTurma()
     {
      this.limpadatas();
      this.modaleditturma.dialog = false;
      this.dados_teams = '';
    },

    fecharModalAlunos()
    {
      this.divAlunos = false;
      this.modalalunosturma.dialog = false;
      this.dados_teams = '';
    },

    fecarmodalVerAlunos()
    {
     this.modalveralunos.dialog = false;
     this.alunosteams = '';
     this.dados_teams = '';
   },

   limpadatas()
   {
    this.dateinicio = '';
    this.datevalidy = '';
    this.dateend = '';
  }
}
};
</script>
<style scoped lang="css">
.custom-class{
  background-color: #b3d4fc!important
}
img {
  width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/turmas/Turmas.vue